import React, { useMemo } from 'react';
import { flex } from '@fabric-ui/theme';
import useQueryObject from '@hooks/useQueryObjectSql';
import { Box, Skeleton, Typography } from '@mui/material';
import { keepPreviousData } from '@tanstack/react-query';
import { getAlertCountUnder5Mins } from './queries';

const MinResolution = ({ filterContext, totalAlertCount }) => {
  const { data: totalAlertCountUnder5Mins, isLoading: isTotalAlertCountUnder5MinsDataLoading } = useQueryObject({
    queryObject: [getAlertCountUnder5Mins(filterContext)],
    options: { placeholderData: keepPreviousData },
    onSuccess: data => data?.[0]?.cnt ?? 0,
  });

  const minResolutionPercentage = useMemo(() => {
    if (isTotalAlertCountUnder5MinsDataLoading || totalAlertCount.isLoading || totalAlertCount.isRefetching) {
      return 0;
    }

    const under5MinsCount = Number(totalAlertCountUnder5Mins) || 0;
    const totalCount = Number(totalAlertCount.data) || 0;

    return totalCount === 0 ? 0 : Math.round((under5MinsCount / totalCount) * 100);
  }, [
    isTotalAlertCountUnder5MinsDataLoading,
    totalAlertCount.isLoading,
    totalAlertCount.isRefetching,
    totalAlertCount.data,
    totalAlertCountUnder5Mins,
  ]);

  return (
    <Box sx={{ padding: '16px 24px', background: 'var(--color-surface-base-primary)', minHeight: '137px', height: '100%', ...flex.col }}>
      <Typography sx={{ fontSize: '14px', marginBottom: '16px', color: 'var(--color-content-base-tertiary)' }} variant="h2">
        Sub-5 Min Resolution
      </Typography>
      {!isTotalAlertCountUnder5MinsDataLoading && !totalAlertCount.isLoading ? (
        <Box display="flex" flexDirection="row" alignItems="baseline" gap="8px">
          <Typography variant="h3" sx={{ m: 0, fontSize: '24px', color: 'var(--color-content-base-primary)' }}>
            {minResolutionPercentage} %
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '13px', color: 'var(--color-content-base-primary)' }}>
            SLA Compliance
          </Typography>
        </Box>
      ) : (
        <Skeleton variant="rectangular" width="100%" height="100%" />
      )}
    </Box>
  );
};

export default MinResolution;
